import React from "react";
import Modal from "../../../Common/Modals";
import ContributionsCalculator from "../../../Common/Calculator";

interface CalculatorModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CalculatorModal: React.FC<CalculatorModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onCancel={onClose} widthSize="md:w-[440px]">
      <ContributionsCalculator onCancel={onClose} />
    </Modal>
  );
};

export default CalculatorModal;
